if (!customElements.get('lr-header-search')) {
  customElements.define('lr-header-search', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.input = this.querySelector('input[type="search"]');
      this.panel = this.querySelector('.lr-header-search__panel');
      this.desktop = window.matchMedia('(min-width: 992px)');
      this.input.addEventListener('focus', () => this.open(), options);
      this.input.addEventListener('input', () => this.open(), options);
      this.addEventListener('focusout', () => {
        requestAnimationFrame(() => { if (!this.contains(document.activeElement)) this.close(); });
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.input.focus({ preventScroll: true });
          this.close();
          event.stopPropagation();
        }
      }, options);
      this.querySelector('.lr-header-search__close').addEventListener('click', () => {
        this.input.focus({ preventScroll: true });
        this.close();
      }, options);
      this.querySelector('form').addEventListener('submit', event => {
        if (!this.input.value.trim()) {
          event.preventDefault();
          this.input.focus({ preventScroll: true });
        }
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.close();
      }, options);
      this.desktop.addEventListener('change', () => {
        if (this.contains(document.activeElement)) this.open();
        else this.close();
      }, options);
      if (this.input === document.activeElement) this.open();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
    open() {
      const hasQuery = this.input.value.trim().length > 0;
      this.toggleAttribute('data-has-query', hasQuery);
      if (this.desktop.matches && !hasQuery) {
        const template = this.querySelector('[data-search-discovery-template]');
        if (template) template.replaceWith(template.content.cloneNode(true));
      }
      this.panel.hidden = !hasQuery && !this.desktop.matches;
      this.setAttribute('data-expanded', String(!this.panel.hidden));
    }
    close() {
      this.panel.hidden = true;
      this.setAttribute('data-expanded', 'false');
      this.querySelector('predictive-search')?.close?.();
    }
  });
}

